export default {
    TRYING_INITIAL_LOGIN: 'TRYING_INITIAL_LOGIN',
    LOADING: 'LOADING',
    LOGGED_OUT: 'LOGGED_OUT',
    LOGGED_IN: 'LOGGED_IN',
    LOGGING_OUT: 'LOGGING_OUT',
};
